import { defineStore } from 'pinia';
import { pcCardLogList } from '@/api/card';

function defaultState() {
  return {
    cardId: '',
    list: [],
    loading: false,
    finished: false,
    pageNum: 1,
    pageSize: 10,
    lastDays: 30,
    currentTrade: null
  };
}

export const useCardBillStore = defineStore('card-bill', {
  state: () => defaultState(),
  actions: {
    reset(cardId = '', lastDays = this.lastDays) {
      Object.assign(this, defaultState());
      this.cardId = cardId || '';
      this.lastDays = Number(lastDays || 180);
    },
    setLastDays(lastDays) {
      this.lastDays = Number(lastDays || 180);
    },
    setCurrentTrade(trade) {
      this.currentTrade = trade || null;
    },
    async fetchNext({ address, cardId, reset = false } = {}) {
      const targetCardId = cardId || this.cardId;
      if (!targetCardId) {
        this.reset('', this.lastDays);
        return [];
      }

      if (reset || targetCardId !== this.cardId) {
        this.reset(targetCardId, this.lastDays);
      }

      if (this.loading || this.finished) {
        return this.list;
      }

      this.loading = true;
      try {
        const result = await pcCardLogList({
          address: address || null,
          cardId: targetCardId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          lastDays: String(this.lastDays)
        });
        const rows = Array.isArray(result?.list) ? result.list : [];
        this.list = this.pageNum === 1 ? rows : [...this.list, ...rows];
        this.finished = rows.length < this.pageSize;
        if (rows.length > 0) {
          this.pageNum += 1;
        }
        return this.list;
      } finally {
        this.loading = false;
      }
    }
  }
});
